import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { SessionSelector } from './SessionSelector';
import { useAppStore } from '../stores/app';

export function Layout() {
  const collapsed = useAppStore((s) => s.sidebarCollapsed);

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <Sidebar />
      <div
        className={`flex-1 flex flex-col transition-all duration-200 ${
          collapsed ? 'ml-16' : 'ml-60'
        }`}
      >
        {/* Top bar */}
        <header className="sticky top-0 z-30 flex items-center justify-between h-14 px-6 border-b border-gray-200 bg-white/80 backdrop-blur">
          <SessionSelector />
          <div className="flex items-center gap-3 text-sm text-gray-500">
            <span>Validation Cockpit</span>
          </div>
        </header>
        {/* Content */}
        <main className="flex-1 p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
